// extracted by mini-css-extract-plugin
module.exports = {"header":"cx_qv","header__content":"cx_qw","header__menu":"cx_qx","header__logo":"cx_qy","header__contacts":"cx_qz"};